import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import auth from "./modules/auth";
import navigation from "./modules/navigation";
import snackbar from "./modules/snackbar";
import item from "./modules/item";
import document from "./modules/documents";
import task from "./modules/task";
import theme from "./modules/theme";
import sockets from "./modules/sockets";
import licences from "./modules/licences";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    auth,
    navigation,
    snackbar,
    item,
    document,
    task,
    theme,
    sockets,
    licences,
  },
});
